<template>
  <div id="app" class="flex-wrapper">
    <router-view name="header" />
    <div class="wrapper">
      <router-view />
    </div>
    <router-view name="footer" />
  </div>
</template>

<script>
export default {};

import Vue from "vue";
import VueRouter from "vue-router";
import device from "vue-device-detector";
import VueYoutube from "vue-youtube";
import VueResource from "vue-resource";

import { config } from "@/utils/config";

// import cookieconsent from 'vue-cookieconsent-component'

// Vue.component('cookie-consent', cookieconsent)
Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(device);
Vue.use(VueYoutube);
import cookieconsent from "vue-cookieconsent-component";

Vue.component("cookie-consent", cookieconsent);
if (config.isGeodidalab) {
  document.title = "Geodidalab";

  var link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "shortcut icon";
  link.href = "https://openalplab.unito.it/assets/icons/geodidalab/favicon.ico";
  document.getElementsByTagName("head")[0].appendChild(link);
} else {
  document.title = "Istituto Mosso";
  var link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "shortcut icon";
  link.href =
    "https://openalplab.unito.it/assets/icons/istitutomosso/favicon.ico";
  document.getElementsByTagName("head")[0].appendChild(link);
}
</script>
<style>
@import "./assets/css/font-awesome.min.css";
@import "./assets/css/templatemo-style.css";
/* @import url('http://fonts.cdnfonts.com/css/sofia-pro'); */

/* // required and to get updates */
@import "../node_modules/vue-cookieconsent-component/src/scss/_cookie-consent.scss";
/* // example or use it */
@import "../node_modules/vue-cookieconsent-component/src/scss/_cookie-consent-bottom.scss";
@import "../node_modules/vue-cookieconsent-component/src/scss/_cookie-consent-transition.scss";

.flex-wrapper {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  justify-content: flex-start;
}

.footer {
  margin-top: auto;
}

.Cookie__button {
  background: #589ee9 !important;
}
</style>
